import { useGetUsersQuery } from '../../Users/services';
import { useGetAssetsQuery } from '../../Assets/service';
import { useGetTypesQuery } from '../../Assets/Types/service';
import { SelectInputOption } from '@/components/inputs/SelectInput';
import { useUserInfo } from '@/hooks';
import { useMemo } from 'react';
import { RequestStatus, RequestStatusLabels } from '../enums';

const useRequestOptions = () => {
  const { id: currentUserId } = useUserInfo();

  const { data: usersData, isLoading: isUsersLoading } = useGetUsersQuery({
    paginated: { page: 1, pageSize: 1000 },
  });

  const { data: assetsData, isLoading: isAssetsLoading } = useGetAssetsQuery({
    paginated: { page: 1, pageSize: 1000 },
  });

  const { data: typesData, isLoading: isTypesLoading } = useGetTypesQuery({
    paginated: { page: 1, pageSize: 1000 },
  });

  const usersOptions: SelectInputOption[] =
    usersData?.items?.map((user) => ({
      value: user.id,
      label: user.fullName,
    })) || [];

  const adminOptions: SelectInputOption[] =
    usersData?.items
      ?.filter((user) => user.id === currentUserId)
      ?.map((user) => ({
        value: user.id,
        label: user.fullName,
      })) || [];

  const requestTypeOptions: SelectInputOption[] = useMemo(() => {
    const types = typesData?.items?.map((type) => ({
      value: type.id,
      label: type.name,
    })) || [];
    
    return [...types, { value: 'OTHER', label: 'Otro' }];
  }, [typesData?.items]);

  const availableAssetsOptions: SelectInputOption[] =
    assetsData?.items
      ?.filter((asset) => asset.status === 'available')
      .map((asset) => ({
        value: asset.id,
        label: `${asset.brand?.name || 'Sin marca'} ${asset.model?.name || 'Sin modelo'} - ${asset.serialNumber}`,
      })) || [];

  const requestStatusOptions: SelectInputOption[] = useMemo(
    () =>
      Object.entries(RequestStatus).map(([statusKey, statusValue]) => ({
        label: RequestStatusLabels[statusValue as RequestStatus],
        value: statusKey,
      })),
    []
  );

  const authenticatedUserExists =
    usersData?.items?.some((user) => user.id === currentUserId) || false;

  return {
    usersOptions,
    adminOptions,
    requestTypeOptions,
    availableAssetsOptions,
    requestStatusOptions,
    isUsersLoading,
    isAssetsLoading: isAssetsLoading || isTypesLoading,
    authenticatedUserExists,
  };
};

export default useRequestOptions;
